module.exports = __webpack_public_path__ + "static/img/11c.7ac8699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11c.jpg
// module id = Y1O0
// module chunks = 0